import {axiosClient} from '../../../core/services/http.service';
import {
  ADD_NEW_CONNECTOR,
  ADD_NEW_SALESFORCE_CONNECTOR,
  ADD_NEW_DYNAMO_CONNECTOR,
  ADD_NEW_ENDPOINT,
  ADD_NEW_STARTING_POINT,
  CLEAR_PREVIEW_DATA,
  CLEAR_STATIC_ENDPOINTS_DATA,
  DELETE_CONNECTOR,
  DELETE_ENDPOINT,
  DELETE_STARTING_POINT,
  DELETE_STATIC_ENDPOINT,
  GET_CONNECTOR_DATA,
  GET_SALESFORCE_NEW_CONNECTOR_DATA,
  GET_DYNAMO_NEW_CONNECTOR_DATA,
  GET_PREVIEW_DATA,
  HIDE_CONNECTOR_MODAL,
  HIDE_ENDPOINT_MODAL,
  HIDE_STARTING_POINT_MODAL,
  SET_ENDPOINT_ENTRY_COLUMNS,
  SET_PITCH_BOOK_ENDPOINTS,
  SET_STATIC_ENDPOINTS_DATA,
  SHOW_CONNECTOR_MODAL,
  SHOW_ENDPOINT_MODAL,
  SHOW_STARTING_POINT_MODAL,
  TOGGLE_CONNECTOR_DATA,
  TOGGLE_CONNECTOR_MODAL,
  TOGGLE_ENDPOINT_DATA,
  TOGGLE_ENDPOINT_MODAL,
  TOGGLE_PREVIEW,
  TOGGLE_STARTING_POINT_DATA,
  TOGGLE_STARTING_POINT_MODAL,
  UPDATE_CONNECTOR,
  UPDATE_ENDPOINT,
  UPDATE_STARTING_POINT,
  UPDATE_STATIC_ENDPOINT,
  SET_CONNECTOR_DATA,
  SET_SALESFORCE_ENDPOINT_PREVIEW,
  SET_NEW_SALESFORCE_STATIC_ENDPOINTS_DATA,
  SET_NEW_DYNAMO_STATIC_ENDPOINTS_DATA,
  SET_DISABLE_DURING_REQUEST,
  DELETE_SALESFORCE_CONNECTOR,
  GET_DYNAMO_CONNECTOR_LIST,
  SET_ENDPOINT_CONFIG,
  SET_DYNAMO_ENDPOINT_CONFIG_MODAL_STATE,
  SET_DYNAMO_DESCRIPTION_SCHEMA_MODAL_STATE,
  UPDATE_DYNAMO_ENDPOINT,
  UPDATE_DYNAMO_SCHEMA,
  UPDATE_DYNAMO_ENDPOINT_CONFIG,
  ADD_ELEMENT_TO_ENDPOINT_CONFIG,
  REMOVE_ELEMENT_TO_ENDPOINT_CONFIG,
  SET_LOADING_STATE,
  SET_PREVIEW,
  DELETE_DYNAMO_CONNECTOR,
  SET_READ_ENABLED_STATE_FOR_ALL_SCHEMAS,
  UPDATE_READ_ONLY_ENABLED_FIELDS,
  SET_PREVIEW_LOADING,
  RESET_DYNAMO_STATE,
} from './mutation-types';
import store from '@/store';

export async function getAllConnector({commit}) {
  commit(TOGGLE_CONNECTOR_DATA, true);
  const response = await axiosClient.get('/api/Connectors');
  if (response.success) {
    commit(GET_CONNECTOR_DATA, response.body);
  }
  commit(TOGGLE_CONNECTOR_DATA, false);
}

export async function getAllSalesforceNewConnector({commit}) {
  commit(TOGGLE_CONNECTOR_DATA, true);
  const response = await axiosClient.get('/api/salesforce');
  if (response.success) {
    commit(GET_SALESFORCE_NEW_CONNECTOR_DATA, response.body);
  }
  commit(TOGGLE_CONNECTOR_DATA, false);
}

export async function getAllDynamoNewConnector({commit}) {
  commit(TOGGLE_CONNECTOR_DATA, true);
  const response = await axiosClient.get('/api/DynamoConnector');
  if (response.success) {
    commit(GET_DYNAMO_NEW_CONNECTOR_DATA, response.body);
  }
  commit(TOGGLE_CONNECTOR_DATA, false);
}

export async function getSalesforceNewConnectorById({commit}, params) {
  commit(TOGGLE_CONNECTOR_DATA, true);

  const {configId} = params;

  const response = await axiosClient.get(`/api/salesforce/${configId}`);

  if (response.success) {
    commit(SET_CONNECTOR_DATA, response.body);
  }
  commit(TOGGLE_CONNECTOR_DATA, false);
}

export async function getDynamoNewConnectorById({commit}, params) {
  commit(TOGGLE_CONNECTOR_DATA, true);

  const {configId} = params;

  const response = await axiosClient.get(`/api/DynamoConnector//${configId}`);

  if (response.success) {
    commit(SET_CONNECTOR_DATA, response.body);
  }
  commit(TOGGLE_CONNECTOR_DATA, false);
}

export async function saveConnector({commit}, {data, action}) {
  commit(TOGGLE_CONNECTOR_MODAL, true);
  const response = await axiosClient.post('/api/Connectors/upsert', data);
  if (response.success) {
    if (action === 'create') {
      commit(ADD_NEW_CONNECTOR, response.body);
    } else {
      commit(UPDATE_CONNECTOR, response.body);
    }
  }
  commit(TOGGLE_CONNECTOR_MODAL, false);
  return response;
}

export async function saveSalesforceNewConnector({commit}, data) {
  commit(TOGGLE_CONNECTOR_MODAL, true);
  const response = await axiosClient.post('/api/salesforce/createnew', data);
  if (response.success) {
    commit(ADD_NEW_SALESFORCE_CONNECTOR, response.body);
  }
  commit(TOGGLE_CONNECTOR_MODAL, false);
  return response;
}

export async function saveDynamoNewConnector({commit}, data) {
  commit(TOGGLE_CONNECTOR_MODAL, true);
  const response = await axiosClient.post('/api/DynamoConnector/createnew', data);
  if (response.success) {
    commit(ADD_NEW_DYNAMO_CONNECTOR, response.body);
  }
  commit(TOGGLE_CONNECTOR_MODAL, false);
  return response;
}

export async function deleteConnector({commit}, configurationId) {
  commit(TOGGLE_CONNECTOR_DATA, true);
  const response = await axiosClient.delete(`/api/Connectors/delete/${configurationId}`);
  if (response.success) {
    commit(DELETE_CONNECTOR, configurationId);
  }
  commit(TOGGLE_CONNECTOR_DATA, false);
  return response;
}

export async function deleteSalesForceNewConnector({commit}, configurationId) {
  commit(TOGGLE_CONNECTOR_DATA, true);
  const response = await axiosClient.delete(`/api/salesforce/${configurationId}`);
  if (response.success) {
    commit(DELETE_SALESFORCE_CONNECTOR, configurationId);
  }
  commit(TOGGLE_CONNECTOR_DATA, false);
  return response;
}

export async function deleteDynamoNewConnector({commit}, configurationId) {
  commit(TOGGLE_CONNECTOR_DATA, true);
  const response = await axiosClient.delete(`/api/dynamoconnector/delete/${configurationId.toUpperCase()}`);
  if (response.success) {
    commit(DELETE_DYNAMO_CONNECTOR, configurationId);
  }
  commit(TOGGLE_CONNECTOR_DATA, false);
  return response;
}

export function showConnectorModal({commit}, data) {
  commit(TOGGLE_CONNECTOR_MODAL, true);
  commit(SHOW_CONNECTOR_MODAL, data);
  commit(TOGGLE_CONNECTOR_MODAL, false);
}

export function setConnectorData({commit}, data) {
  commit(SET_CONNECTOR_DATA, data);
}

export function hideConnectorModal({commit}) {
  commit(HIDE_CONNECTOR_MODAL);
}

export function showEndpointModal({commit}, data) {
  commit(SHOW_ENDPOINT_MODAL, data);
}

export function hideEndpointModal({commit}) {
  commit(HIDE_ENDPOINT_MODAL);
}

export async function saveEndpoint({commit}, {data, action}) {
  commit(TOGGLE_ENDPOINT_MODAL, true);
  const response = await axiosClient.post('/api/Connectors/upsert-endpoint', data);

  if (response.success) {
    if (action === 'create') {
      commit(ADD_NEW_ENDPOINT, response.body);
    } else {
      commit(UPDATE_ENDPOINT, response.body);
    }
  }
  commit(TOGGLE_ENDPOINT_MODAL, false);
  return response;
}

export function updateStaticEndpoint({commit}, endpoint) {
  commit(UPDATE_STATIC_ENDPOINT, endpoint);
}

export async function deleteEndpoint({commit}, data) {
  commit(TOGGLE_ENDPOINT_DATA, true);
  const response = await axiosClient.delete(`/api/Connectors/delete-endpoint/${data.endpointId}`);
  if (response.success) {
    commit(DELETE_ENDPOINT, data);
    if (data.isStaticEndpoint) {
      commit(DELETE_STATIC_ENDPOINT, data);
    }
  }
  commit(TOGGLE_ENDPOINT_DATA, false);
  return response;
}

export async function getEndpointPreview({commit}, params) {
  commit(TOGGLE_PREVIEW, true);
  const res = await axiosClient.get(`/api/Connectors/preview/${params.configurationId}/${params.endpointId}`);
  if (res.success) {
    commit(GET_PREVIEW_DATA, res.body);
  }
  commit(TOGGLE_PREVIEW, false);
  return res;
}

export function clearPreviewData({commit}) {
  commit(CLEAR_PREVIEW_DATA);
}

export async function saveEndpointPreview({commit}, params) {
  commit(TOGGLE_ENDPOINT_DATA, true);
  const res = await axiosClient.post(`/api/Connectors/save/${params.configurationId}/${params.endpointId}`);
  commit(TOGGLE_ENDPOINT_DATA, false);
  return res;
}

export async function saveAllEndpointPreview({commit}, configurationId) {
  commit(TOGGLE_CONNECTOR_DATA, true);
  const res = await axiosClient.post(`/api/Connectors/save/${configurationId}`);
  commit(TOGGLE_CONNECTOR_DATA, false);
  return res;
}

export function showStartingPointModal({commit}, data) {
  commit(SHOW_STARTING_POINT_MODAL, data);
}

export function hideStartingPointModal({commit}) {
  commit(HIDE_STARTING_POINT_MODAL);
}

export async function saveStartingPoint({commit}, {data, action}) {
  commit(TOGGLE_STARTING_POINT_MODAL, true);
  const response = await axiosClient.post('/api/Connectors/upsert-starting-point', data);
  if (response.success) {
    if (action === 'create') {
      commit(ADD_NEW_STARTING_POINT, response.body);
    } else {
      commit(UPDATE_STARTING_POINT, response.body);
    }
  }
  commit(TOGGLE_STARTING_POINT_MODAL, false);
  return response;
}

export async function deleteStartingPoint({commit}, data) {
  commit(TOGGLE_STARTING_POINT_DATA, true);
  const response = await axiosClient.delete(`/api/Connectors/delete-starting-point/${data.startingPointId}`);
  if (response.success) {
    commit(DELETE_STARTING_POINT, data);
  }
  commit(TOGGLE_STARTING_POINT_DATA, false);
  return response;
}

export async function getPitchBookEndpoints({commit}, params = {}) {
  commit(TOGGLE_CONNECTOR_DATA, true);
  const response = await axiosClient.get('/api/Connectors/pitchbook/endpoints');
  if (response.success) {
    commit(SET_PITCH_BOOK_ENDPOINTS, {
      data: response.body,
      keyMap: params.keyMap || false,
    });
  }
  commit(TOGGLE_CONNECTOR_DATA, false);
  return response;
}

export async function getStaticEndpoints({commit}, params) {
  commit(TOGGLE_CONNECTOR_DATA, true);
  const response = await axiosClient.get(`/api/connectors/${params.vendor.toLowerCase()}/get-entities/${params.configurationId}`);

  if (response.success) {
    commit(SET_STATIC_ENDPOINTS_DATA, {
      data: response.body,
    });
  }

  commit(TOGGLE_CONNECTOR_DATA, false);
  return response;
}

export async function getSalesforceNewStaticEndpoints({commit}, params) {
  commit(TOGGLE_CONNECTOR_DATA, true);
  const response = await axiosClient.get(`/api/salesforce/GetAllEndpoints/${params.configId}`);
  if (response.success) {
    commit(SET_NEW_SALESFORCE_STATIC_ENDPOINTS_DATA, {
      data: response.body,
    });
  }

  commit(TOGGLE_CONNECTOR_DATA, false);
  return response;
}

export async function getDynamoNewStaticEndpoints({commit}, params) {
  commit(TOGGLE_CONNECTOR_DATA, true);
  const response = await axiosClient.get(`/api/DynamoConnector/ListDynamoEntites/${params.configId}`);
  if (response.success) {
    commit(SET_NEW_DYNAMO_STATIC_ENDPOINTS_DATA, {
      data: response.body,
    });
  }

  commit(TOGGLE_CONNECTOR_DATA, false);
  return response;
}

export async function getEfrontReports({commit}, {configurationId, endpoints}) {
  const {success, body} = await axiosClient.get(`/api/connectors/efront/get-reports/${configurationId}`);
  if (success) {
    commit(SET_STATIC_ENDPOINTS_DATA, {
      isEfront: true,
      data: body,
      endpoints: endpoints || [],
    });
  }
}

export function clearStaticEndpointsData({commit}) {
  commit(CLEAR_STATIC_ENDPOINTS_DATA);
}

export async function createStaticEndpoint({commit}, params) {
  commit(TOGGLE_CONNECTOR_DATA, true);
  const response = await axiosClient.post(`/api/connectors/create-${params.vendor.toLowerCase()}-endpoint/${params.configurationId}`, params.item);
  if (response.success) {
    commit(ADD_NEW_ENDPOINT, response.body);
    response.body.index = params.item.index;
    commit(UPDATE_STATIC_ENDPOINT, response.body);
  }
  commit(TOGGLE_CONNECTOR_DATA, false);
  return response;
}

export async function generatePitchBook({commit}) {
  commit(TOGGLE_CONNECTOR_DATA, true);
  const res = await axiosClient.post('/api/Connectors/pitchbook/generate-all');
  commit(TOGGLE_CONNECTOR_DATA, false);
  return res;
}

export async function generateSQLServer({commit}) {
  commit(TOGGLE_CONNECTOR_DATA, true);
  const res = await axiosClient.post('/api/Connectors/sqlsrvr');
  commit(TOGGLE_CONNECTOR_DATA, false);
  return res;
}

export async function updateEndpointEntity({commit}, endpoint) {
  return await axiosClient.post(`/api/connectors/update-external-system-table/${endpoint.endpointId}`);
}

export async function getEndpointEntryColumns({commit}, {endpoints, isDealCloud, configurationId}) {
  const {success, body} = await axiosClient.get(`/api/connectors/entity-columns-for-config/${configurationId}`);

  if (success) {
    commit(SET_ENDPOINT_ENTRY_COLUMNS, body);
  }
}

export async function getSalesforceEndpointPreview({commit}, params) {
  commit(TOGGLE_PREVIEW, true);
  commit(SET_SALESFORCE_ENDPOINT_PREVIEW, []);

  const {connectorInstanceId, endpointId} = params;
  const res = await axiosClient.get(`/api/salesforce/${connectorInstanceId}/${endpointId}/preview`);
  if (res.success) {
    commit(SET_SALESFORCE_ENDPOINT_PREVIEW, res.body);
  }

  commit(TOGGLE_PREVIEW, false);
  return res;
}

export async function createSalesforceStaticEndpoint({commit}, params) {
  commit(TOGGLE_PREVIEW, true);
  commit(SET_DISABLE_DURING_REQUEST, true);

  const {configurationId, endpointName} = params;
  const res = await axiosClient.post(`/api/salesforce/AddEndpoint/${configurationId}/${endpointName}`);
  commit(SET_CONNECTOR_DATA, res.body);

  commit(TOGGLE_PREVIEW, false);
  commit(SET_DISABLE_DURING_REQUEST, false);
  return res;
}

export async function createDynamoStaticEndpoint({commit}, params) {
  commit(TOGGLE_PREVIEW, true);
  commit(SET_DISABLE_DURING_REQUEST, true);

  const {configurationId, endpointName} = params;
  //TODO this needs to get in as data, differently
  const res = await axiosClient.post(`/api/DynamoConnector/AddNewEndpoint/${configurationId}/${endpointName}`);
  commit(SET_CONNECTOR_DATA, res.body);

  commit(TOGGLE_PREVIEW, false);
  commit(SET_DISABLE_DURING_REQUEST, false);
  return res;
}

export async function removeSalesforceStaticEndpoint({commit}, params) {
  commit(TOGGLE_PREVIEW, true);
  commit(SET_DISABLE_DURING_REQUEST, true);

  const {configurationId, endpointName} = params;
  const res = await axiosClient.delete(`/api/salesforce/RemoveEndpoint/${configurationId}/${endpointName}`);
  if (res.success) {
    commit(SET_CONNECTOR_DATA, res.body);
  }

  commit(TOGGLE_PREVIEW, false);
  commit(SET_DISABLE_DURING_REQUEST, false);
  return res;
}

export async function updateSalesforceEndpoint({commit}, params) {
  commit(TOGGLE_CONNECTOR_DATA, true);
  commit(SET_DISABLE_DURING_REQUEST, true);

  const {configurationId, body} = params;
  const res = await axiosClient.post(`/api/salesforce/UpdateEndpoint/${configurationId}`, body);
  if (res.success) {
    commit(SET_CONNECTOR_DATA, res.body);
  }

  commit(TOGGLE_CONNECTOR_DATA, false);
  commit(SET_DISABLE_DURING_REQUEST, false);

  return res;
}

export async function getSalesforceCompleteConfig({commit}, params) {
  commit(TOGGLE_PREVIEW, true);

  const {configId} = params;
  const res = await axiosClient.get(`/api/salesforce/GetCompleteConfig/${configId}`);

  commit(TOGGLE_PREVIEW, false);

  return res;
}

export async function updateSalesforceNewConnector({commit}, params) {
  commit(TOGGLE_PREVIEW, true);

  const {configurationId, body} = params;
  const res = await axiosClient.patch(`/api/salesforce/UpdateConfig/${configurationId}`, body);
  if (res.success) {
    commit(SET_CONNECTOR_DATA, res.body);
  }

  commit(TOGGLE_PREVIEW, false);

  return res;
}

export async function updateDynamoNewConnector({commit}, params) {
  commit(TOGGLE_PREVIEW, true);
  const {body, configurationId} = params;
  const res = await axiosClient.post(`/api/dynamoconnector/updateconfig/${configurationId}`, body);
  if (res.success) {
    await store.dispatch('connectorScreen/getAllDynamoNewConnector');
    commit(SET_CONNECTOR_DATA, res.body);
  }

  commit(TOGGLE_PREVIEW, false);

  return res;
}

export const getDynamoConnectorPreview = async ({commit}, {connectorId, endpointId}) => {
  commit(SET_PREVIEW_LOADING, true);
  await store.dispatch('connectorScreen/setPreview',  null);
  const {success, body} = await axiosClient.get(`/api/dynamoconnector/preview/${connectorId}/${endpointId}`);
  if(success) {
    await store.dispatch('connectorScreen/setPreview', {body, endpointId });
  }
  commit(SET_PREVIEW_LOADING, false);
  return {body};
};

const sortEndpointsFieldSchemas = (obj) => {
  return obj.fieldSchemas.sort((a, b) => {
    const prev = a.columnName.toLowerCase();
    const current = b.columnName.toLowerCase();
    if (prev < current) {
      return -1;
    }
    if (prev > current) {
      return 1;
    }
    return 0;
  }).filter(el => !el.isBusinessKey);
};

export const getDynamoConnectorsConfig = async ({commit}, id) => {
  const {success, body} = await axiosClient.get(`/api/dynamoconnector/getconfig/${id}`);
  const sortedBody = {
    ...body,
    endpointConfigs: body.endpointConfigs.map(el => 
      el = {
        ...el, 
        fieldSchemas: sortEndpointsFieldSchemas(el),
      },
    ),
  };
  if (success) {
    commit(SET_ENDPOINT_CONFIG, sortedBody);
  }
  return sortedBody;
};

export const getDynamoConnectorsList = async ({commit, dispatch}, id) => {
  const configResp = await store.dispatch('connectorScreen/getDynamoConnectorsConfig', id);
  const {
    success: isListStatusSuccess,
    body: listBody,
  } = await axiosClient.get(`/api/dynamoconnector/listdynamoentites/${id}`);

  if (isListStatusSuccess && configResp && ('endpointConfigs' in configResp)) {
    const transformedListData = listBody.map(el => {
      const isEndpointExists = configResp.endpointConfigs.find(endpoint => endpoint.dynamoName === el.name);
      return {
        ...el,
        isAdded: !!isEndpointExists,
        endpointGuid: isEndpointExists ? isEndpointExists.endpointGuid : null,
      };
    });
    commit(GET_DYNAMO_CONNECTOR_LIST, transformedListData);
  }
  return listBody;
};


export const addNewDynamoEndpoint = async ({commit}, payload) => {
  commit(SET_LOADING_STATE, true);
  const {success, body} = await axiosClient.post('/api/dynamoconnector/addnewendpoint', payload);
  const sortedBody = {
    ...body,
    fieldSchemas: sortEndpointsFieldSchemas(body),
  };

  if (success) {
    commit(ADD_ELEMENT_TO_ENDPOINT_CONFIG, sortedBody);
  }
  commit(SET_LOADING_STATE, false);
  return success;
};

export const deleteDynamoEndpoint = async ({commit}, {connectorId, endpointId}) => {
  const {success} = await axiosClient.delete(`/api/dynamoconnector/deleteendpoint/${connectorId}/${endpointId}`);

  if(success) {
    commit(REMOVE_ELEMENT_TO_ENDPOINT_CONFIG, endpointId);
  }
  return success;
};

export const updateDynamoEndpoint = async ({commit}, {id, payload}) => {
  const {success} = await axiosClient.post(`/api/dynamoconnector/updateendpoint/${id}`, payload);
  if(success) {
    commit(UPDATE_DYNAMO_ENDPOINT, payload);
    await store.dispatch('connectorScreen/setDynamoEndpointConfigModalState', {
      isOpen: false,
      data: null,
    });
  }
  return success;
};

export const setDynamoEndpointConfigModalState = ({commit}, payload) => {
  commit(SET_DYNAMO_ENDPOINT_CONFIG_MODAL_STATE, payload);
};
export const setDynamoDescriptionSchemaModalState = ({commit}, payload) => {
  commit(SET_DYNAMO_DESCRIPTION_SCHEMA_MODAL_STATE, payload);
};

export const updateDynamoSchema = ({commit}, payload) => {
  commit(UPDATE_DYNAMO_SCHEMA, payload);
};

export const updateDynamoEndpointConfig = ({commit}, payload) => {
  commit(UPDATE_DYNAMO_ENDPOINT_CONFIG, payload);
};

export const setPreview = ({commit}, payload) => {
  commit(SET_PREVIEW, payload);
};

export const setReadEnabledStateForAllSchemas = ({commit}, payload) => {
  commit(SET_READ_ENABLED_STATE_FOR_ALL_SCHEMAS, payload);
};

export const updateReadOnlyEnabledFields = ({commit}, payload) => {
  commit(UPDATE_READ_ONLY_ENABLED_FIELDS, payload);
};

export const resetDynamoState = ({commit}) => {
  commit(RESET_DYNAMO_STATE);
};